import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionDescription(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.aboutDescription)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h2 className={classes.description, classes.textCenter}>
            FIRST-CLASS BUSINESS, IN A FIRST-CLASS WAY
          </h2>


          <h5>
            We are committed to a distinctive culture and set of core values. These values are reflected in our Business Principles,
             which emphasize placing our client's interests first, integrity, commitment to excellence and innovation, and teamwork.
          </h5>
          <h5>Kinos focus is on our clients investment needs and preferences. We have consistently delivered attractive results, despite changing market.
conditions and across market cycles.</h5>
          <h5>Our goal is to be the advisor of choice for our clients and a leading participant in global real estate and financial markets. Kinos provide services customers around worldwide, to a substantial and diversified client base, which includes, family office, corporations, financial institutions, governments, sovereign wealth funds and high net worth individuals.
</h5>
          <h3>SERVICES FOR INVESTORS</h3>
          <h5>We provide a robust range of investor services designed to drive real estate performance and asset value.
Our leadership position in relations and network provides us with access to family offices, financial institutions and corporate clients globally.
 Managing real estate wealth is one of the fastest growing segments of the real estate services industry and we are positioning our asset management and brokerage services to take advantage of that growth.</h5>
          <h5></h5>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(descriptionStyle)(SectionDescription);
